import { Component } from '@angular/core';

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: ` <span> </span> `,
    standalone: false
})
export class FooterComponent {}
